import { BaseService } from "./BaseService";
import {
    CheckoutSettingsResponse,
    CreateCheckoutSettings,
    UpdateCheckoutSettings,
} from "@/types/booking-checkout-settings";

class BookingCheckoutSettingsService extends BaseService {
    private basePath = '/booking-checkouts/settings'

    constructor() {
        super();
    }

    async getSettings(): Promise<CheckoutSettingsResponse> {
        return this.get<CheckoutSettingsResponse>(this.basePath);
    }

    async createSettings(
        data: CreateCheckoutSettings
    ): Promise<CheckoutSettingsResponse> {
        return this.post<CheckoutSettingsResponse>(this.basePath, data);
    }

    async updateSettings(
        data: UpdateCheckoutSettings
    ): Promise<CheckoutSettingsResponse> {
        return this.put<CheckoutSettingsResponse>(this.basePath, data);
    }

    async getCheckoutRecommendedServices(hotelId: string): Promise<any> {
        return this.get<any>(`/booking-checkouts/hotels/${hotelId}/checkout-recommended-services`);
    }

    async updateCheckoutRecommendedServices(hotelId: string, serviceIds: string[]): Promise<any> {
        return this.post<any>(`/booking-checkouts/hotels/${hotelId}/checkout-recommended-services`, serviceIds);
    }

    async getFinalCheckoutUpsellServices(hotelId: string): Promise<any> {
        return this.get<any>(`/booking-checkouts/hotels/${hotelId}/final-checkout-upsell-services`);
    }

    async updateFinalCheckoutUpsellServices(hotelId: string, serviceIds: string[]): Promise<any> {
        return this.post<any>(`/booking-checkouts/hotels/${hotelId}/final-checkout-upsell-services`, serviceIds);
    }
}

export const bookingCheckoutSettingsService = new BookingCheckoutSettingsService();
